import { apiRequest } from "./apiClient";

export const getHomeImages = async (section) => {
 try {
  const data = await apiRequest(`/home-images?section=${encodeURIComponent(section)}`);
  return data.images || [];
 } catch (error) {
  return null;
 }
};

export const getCustomerFeedback = async () => {
 try {
  const data = await apiRequest("/customer-feedback");
  return data.feedback || [];
 } catch (error) {
  return null;
 }
};

export const getScootyFeatureConfig = async () => {
 try {
  const data = await apiRequest("/scooty-feature-config");
  return data.config || null;
 } catch (error) {
  return null;
 }
};